<ng-container>
  <div class="detail-header pt-4 pb-0">
    <a  onclick="window.print()" class="export-btn d-print-none" style="width: 100px;">Print</a>
    <div class="h3-text d-inline-block" style="vertical-align: sub;">{{ account ? account : 'Overview' }}</div>
    <h1>{{ plan?.PlanName ? plan?.PlanName : 'All Accounts' }} {{ plan?.Currency === 'USD' && plan?.PlanName !== 'All USD Accounts'?'(USD)': '' }}</h1>
  </div>
  <div class="detail-header sticky pt-1 d-print-none">
    <SubMenu [items]="subMenuItems" />
  </div>
  <h1 class="mt-5 mb-2 d-none d-print-block" style="margin-right: 120px">
    Portfolio <span class="as-of">As Of {{valuationDate | date:'MMMM d, yyyy'}}</span>
  </h1>
  <h1 class="d-inline-block pt-4" style="vertical-align: sub;">Summary</h1>
  @if (!isPershing) {
    <a routerLink="/resource/pricing" class="ml-3 d-print-none" aria-label="Detailed Pricing Schedule">
      <i class="i" [ngbTooltip]="'Click for detailed pricing schedule'" placement="top"></i>
    </a>
  }
  <div class="row">
    <div class="col-md-6 mt-3">
      <a class="summary-box dblue-bg nolink">
        <div>
          <span class="total">{{portfolio?.total | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}</span>
          @if (!isPershing) {
            <p class="summary-box-header">{{plan ? plan_prefix + 'Account Market Value' + plan_postfix : 'Total Portfolio In CAD'}}</p>
          }
          @if (isPershing) {
            <p  class="summary-box-header">{{plan ? plan_prefix + 'Account Market Value' + plan_postfix : 'Total Portfolio In USD'}}</p>
          }
        </div>
      </a>
    </div>
    <div class="col-md-6 mt-3">
      <a class="summary-box dblue-bg nolink">
        <div>
          <span class="total">{{portfolio?.blendedAnnualized | percent:'1.2-2' | minusSignToParens}}</span>
          @if (daysSinceInception && daysSinceInception <= 365) {
            <span class="ARSI-star" aria-hidden="true" [ngbTooltip]="'Funds are invested for less than one year. Displayed return uses YTD return formula, refer to the FAQ page.'" placement="top" container="body" style="font-size:18pt">* </span>
          }
          <p class="summary-box-header">Total Annualized Return Since Inception <font class="text-nowrap">{{ portfolio?.inceptionDate | date:'MMM d, yyyy'}}</font></p>
        </div>
      </a>
    </div>
  </div>

  @if (portfolio && portfolio.otherHoldings > 0) {
    <div class="row">
      <div class="col-md-6 mt-3">
        <a class="summary-box brown-bg nolink">
          <div>
            <span class="total">{{portfolio.otherHoldings | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}</span>
            <p class="summary-box-header">{{plan ? 'Other Holdings':'Total Other Holdings (CAD)'}}</p>
          </div>
        </a>
      </div>
      <div class="col-md-6 mt-3">
        <a class="summary-box brown-bg nolink">
          <div>
            <span class="total">{{portfolio.totalWithOtherHoldings | currency:'USD': 'symbol':'1.0-0' | minusSignToParens}}</span>
            @if (!isPershing) {
              <p class="summary-box-header">{{plan ? 'Total Account Market Value':'Total Portfolio (CAD)'}}</p>
            }
          </div>
        </a>
      </div>
      <div class="col-12 text-right small pt-1">Other holdings are not included in performance or asset allocation.</div>
    </div>
  }
  @if (portfolio && !plan && !isPershing) {
    <div class="pt-3 text-right d-print-none">FX RATE = {{portfolio!.fxRate.UsdToCadRate | number:'1.4-4'}} as of {{portfolio!.fxRate.RateDate | date:'MMM d, yyyy'}}</div>
  }
  <br />


  @if (portfolio) {
    <div class="pt-2">
      <a class="anchor" id="returns" data-offset="-35" aria-hidden="true"></a>
      <h1>Performance</h1>
      @if (valuationDate) {
        <div class="row">
          <div class="col-md-6 pb-3" [ngClass]="{'chart-loaded':CYRChart_loaded}">
            <div class="chart-block">
              <div class="card-header dblue-bg">
                <div>
                  Calendar Year Returns
                  <a routerLink="/details/cyr/{{plan?.id || ''}}" style="width:calc(100% - 170px);">
                    <span class="material-icons">arrow_forward_ios</span>
                  More Details</a>
                </div>
              </div>
              <div class="p-xl-2">
                <CYRChart [plan]="plan?.id || ''" [limit]="5" (loaded)="CYRChart_loaded=$event" />
              </div>
            </div>
          </div>
          <div class="col-md-6 pb-3">
            <div class="chart-block">
              <div class="card-header dblue-bg" style="min-height: 33px;">
                Annualized Returns ending {{ ARChart.MEValuationDate | date:'MMM d, yyyy'}}
              </div>
              <div class="p-xl-2">
                <ARChart [plan]="plan?.id || ''" [inception]="portfolio!.inceptionDate" #ARChart />
              </div>
            </div>
          </div>
          <div class="col-md-6 py-3" [ngClass]="{'chart-loaded':AICFChart_loaded}">
            <div class="chart-block">
              <div class="card-header dblue-bg">
                <div>
                  Net Amount Invested & Cumulative Profit
                  <a routerLink="/details/aicp/{{plan?.id || ''}}" style="width:calc(100% - 295px);">
                    <span class="material-icons">arrow_forward_ios</span>
                  More Details</a>
                </div>
              </div>
              <div class="p-xl-2">
                <p class="card-text ifChartLoaded legend">
                  <span><i class="fa fa-circle" aria-hidden="true"></i>Net Amount Invested</span>
                  <span><i class="fa fa-circle" aria-hidden="true" style="color:#88A8A3"></i>Profit</span>
                </p>
                <AICFChart [plan]="plan?.id || ''" [limit]="20" (loaded)="AICFChart_loaded=$event" />
              </div>
            </div>
          </div>
          <div class="col-md-6 py-3" [ngClass]="{'chart-loaded':CFCYChart_loaded}">
            <div class="chart-block">
              <div class="card-header dblue-bg">
                <div>
                  Cash Flow (Net of Fees) and Cash Yield (%)
                  @if (daysSinceInception && daysSinceInception > 365) {
                    <a routerLink="/details/cfcy/{{plan?.id || ''}}" style="width:calc(100% - 310px);">
                      <span class="material-icons">arrow_forward_ios</span>
                    More Details</a>
                  }
                </div>
              </div>
              <div class="p-xl-2">
                @if (daysSinceInception && daysSinceInception > 365) {
                  <CFCYChart [plan]="plan?.id || ''" [limit]="5" (loaded)="CFCYChart_loaded=$event" />
                }
                @if (daysSinceInception && daysSinceInception <= 365) {
                  <div class="p-2">
                    <div class="h6-text">Your Historical Portfolio Cash Flow Summary will become available once your accounts have been generating cash flow for a full 12
                      months. You can expect to see detailed information here showing how much cash flow your portfolio is generating quarterly,
                      annually, and over a rolling 10-year period.<br><br>
                      We focus on acquiring assets that have strong, sustainable cash flow because the dividends, interest payments, and rental income
                      provided by these assets are far less volatile than their price. Option premiums earned on writing options on equities provide a
                      further margin of safety.<br><br>
                      The cash flow generated by a well-diversified portfolio is, in our opinion, a critical component of your long-term investment returns
                    and we are pleased to make it a standard element of your financial reporting.</div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div class="py-3">
    <a class="anchor" id="asset" data-offset="-35" aria-hidden="true"></a>
    <h1>Asset Allocation</h1>
    @if (valuationDate) {
      <div>
        <PortfolioAllocation [plan]="plan?.id || ''" />
      </div>
    }
  </div>
</ng-container>

@if (plan && portfolio && inceptionDate && plan.id!=='CAD' && plan.id!=='USD' && portfolio.inceptionDate) {
  <div>
    <div class="pb-3">
      <a class="anchor" id="investments" data-offset="-35" aria-hidden="true"></a>
      <portfolio-assets [isPershing]="isPershing" [plan]="plan" [isPortfolioInvestmentPage]="true" [YTDReturn]="portfolio.ytdReturn" [InceptionReturn]="portfolio!.blendedAnnualized" [CadYTDReturn]="portfolio.CadytdReturn" [CadInceptionReturn]="portfolio!.CadblendedAnnualized" #PoA />
    </div>
    <div class="pb-3">
      <a class="anchor" id="transactions" data-offset="-35" aria-hidden="true"></a>
      <a tabindex="0" role="button" (click)="PTr.export([[plan.title + ' - Transactions']], [{row:0, font: '14'}])" class="export-btn pull-right d-print-none">Export</a>
      <h1 class="my-4">Transaction Details</h1>
      <portfolio-transactions [plan]="plan" [inceptionDate]="inceptionDate" #PTr />
    </div>
  </div>
}
